export default function hideHeaderScrollDown() {
    let prevScrollpos = window.pageYOffset;

    document.addEventListener('scroll', () => {
        const header = document.querySelector('.page-header');
        if(!header) return;
        let currentScrollPos = window.pageYOffset;

        if (prevScrollpos > currentScrollPos) {
            header.style.top = '0';
        }

        if(prevScrollpos < currentScrollPos && currentScrollPos > 50) {
            header.style.top = '-6em';
        }

        prevScrollpos = currentScrollPos <= 0 ? 0 : currentScrollPos;

        if(currentScrollPos > window.innerHeight - 100) {
            header.classList.add('page-header--light');
        } else {
            header.classList.remove('page-header--light');
        }
    });
}
